export default "__VITE_PUBLIC_ASSET__b6693578__"